module.exports = __webpack_public_path__ + "img/order_photo_image@3x.50adc7bc.png";